import { z } from 'zod';
import { ReachAPI } from '../ReachApi';

const AssetInfoSchema = z.object({
    assets: z.array(
        z.object({
            type: z.string(),
            redirect: z.string(),
        })
    ),
});

export async function getVideoAssetUrl(assetUuid: string, mimeType = 'video/mp4'): Promise<string> {
    const response = AssetInfoSchema.parse(await ReachAPI.cdn.getAssetInfo(assetUuid));
    const assets = response.assets.filter(function (asset) {
        return asset.type === mimeType;
    });
    if (assets.length < 1) {
        throw ReferenceError(`No '${mimeType}' asset exists for '${assetUuid}'`);
    }
    return assets[0].redirect;
}
